import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  theme: 'light' | 'dark' = 'light';

  private themeSubject =
    new BehaviorSubject<'light' | 'dark'>(this.theme);

  theme$ = this.themeSubject.asObservable();

  constructor(private ngZone: NgZone) {
    window.addEventListener('storage', this.handleStorageChange);
  }

  setTheme(theme: 'light' | 'dark') {
    this.applyTheme(theme);
  }

  loadTheme() {

    const theme =
      this.normalizeTheme(localStorage.getItem('theme'))
      || this.theme
      || 'light';

    this.setTheme(theme);
  }

  private handleStorageChange = (event: StorageEvent) => {
    if (event.key !== 'theme') {
      return;
    }

    const theme = this.normalizeTheme(event.newValue);
    if (!theme || theme === this.theme) {
      return;
    }

    this.ngZone.run(() => this.applyTheme(theme, false));
  };

  private applyTheme(theme: 'light' | 'dark', persist = true) {
    this.theme = theme;

    document.body.setAttribute(
      'data-bs-theme',
      theme
    );

    if (persist) {
      localStorage.setItem('theme', theme);
    }

    this.themeSubject.next(theme);
  }

  private normalizeTheme(theme: string | null): 'light' | 'dark' | null {
    const normalizedTheme = theme?.toLowerCase();
    return normalizedTheme === 'light' || normalizedTheme === 'dark'
      ? normalizedTheme
      : null;
  }
}
